export default __webpack_public_path__ + "static/card-two-09d8be5a6f31e78fe30411719ab74d5d.jpg";